// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-2500ffa0]:export {\n  menuBg: #E25527;\n  menuText: #ffffff;\n  menuActiveText: #E25527;\n  menuActiveBg: #ffffff;\n}\n\n/* Mixins */\n.small[data-v-2500ffa0] {\n  font-size: 9px;\n}\n.el-button--mini[data-v-2500ffa0] {\n  padding: 0;\n  border: 0;\n}", ""]);
// Exports
module.exports = exports;
